'use client';

import type { FC } from 'react';
import { LoginForm } from '@/components/raven/global/LoginForm';
import { useLoginFormProps } from '@/utils/hooks/use-login-form';
import { HEADER_ACCOUNT_BUTTON } from '@/utils/comments/constants';

export const LoginComponent: FC<React.PropsWithChildren> = ({ children }) => {
	const loginFormProps = useLoginFormProps({
		location: HEADER_ACCOUNT_BUTTON,
		loginKey: 'accountPageLogin',
	});

	return <LoginForm {...loginFormProps} />;
};
